import userSessionStorage from '@/context/userSessionStorage'
import { siteUrl } from '../shared/utils/siteUrl'

import pushEventDataLayerObj from './pushEventDataLayer'
import stringToHash, { jsonToHash } from './crypto'

/**
 *  PARSE FROME XCEL
 *  json={};
 *  s=` .... excel `
 *  json={};s.replaceAll("\t","|").replaceAll('|||','').split("\n").filter((str)=>str.trim().length>1).map((str)=>  str.split("|")  ).forEach((arr)=>{  json[arr[0]]={event:arr[1],category:arr[2],action:arr[3]}; })
 *
 */

interface ITagData {
  event?: string
  category?: string
  action?: string
}
var executed = false
const attribute_tag_names = ['data-tag']
const default_category = 'Wall_Love'
const TAGS: { [key: string]: ITagData } = {
  '0z': {
    event: 'Interactions_test',
  },

  '6A': {
    event: 'Interacciones_Menú_Wall_Love',
    category: 'Wall_Love',
    action: 'click',
  },
  '7A': {
    event: 'Interacciones_Video_Inicio',
    category: 'Wall_Love',
    action: 'click',
  },
  '8A': {
    event: 'Interacciones_Video_Expertas',
    category: 'Wall_Love',
    action: 'click',
  },
  '9A': {
    event: 'Interacciones_Consultorio_Gratuito',
    category: 'Wall_Love',
    action: 'click',
  },
  '10A': {
    event: 'Interacciones_Descargables',
    category: 'Wall_Love',
    action: 'click',
  },
  '11A': {
    event: 'Interacciones_Firma',
    category: 'Wall_Love',
    action: 'click',
  },
  '12A': {
    event: 'Interacciones_Foro',
    category: 'Wall_Love',
    action: 'click',
  },
}

const isSSR = typeof window === 'undefined'

const default_location = siteUrl
const stored_user_data = {
  log_status: 'Not',
}
function getUserInfo() {
  return userSessionStorage.getUserInfo()
}
async function getUserData() {
  const userInfo = getUserInfo()
  const logged = userInfo !== null
  const log_status = logged ? 'Yes' : 'Not'
  if (stored_user_data.log_status === log_status) {
    return stored_user_data
  }
  if (logged) {
    stored_user_data.user_data = logged
      ? [
          await jsonToHash({
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location?.cityName,
            departamento: userInfo.location?.countryStateName,
            pais: userInfo.countryName,
          }),
        ]
      : []
  }

  stored_user_data.log_status = log_status
  return stored_user_data
}

async function pushData(obj) {
  const user = await getUserData()
  pushEventDataLayerObj({
    location: window ? window.location.href : default_location,

    category: default_category,
    ...obj,
    ...user,
  })
}
const observeDOM =
  !isSSR &&
  (function () {
    var MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver

    return function (obj: HTMLElement, callback: () => void) {
      if (!obj || obj.nodeType !== 1) return

      if (MutationObserver) {
        // define a new observer
        var mutationObserver = new MutationObserver(callback)

        // have the observer observe for changes in children
        mutationObserver.observe(obj, { childList: true, subtree: true })
        return mutationObserver
      }

      // browser support fallback
      else if (window.addEventListener) {
        obj.addEventListener('DOMNodeInserted', callback, false)
        obj.addEventListener('DOMNodeRemoved', callback, false)
      }
    }
  })()
let debounceTimeId = 0

const bindsLinks: (() => void)[] = []
const onBindTagClick = (tagname: string, evt: any) => {
  if (!evt.target.attributes[tagname]) {
    return
  }
  if (evt.target.attributes[tagname].value.trim().length === 0) {
    return
  }
  const tag = evt.target.attributes[tagname].value
  const tagdata = TAGS[tag]
  pushData({
    tag,
    action: 'click',
    label: evt.target.innerText,
    ...tagdata,
  })
}
function clearBindLinks() {
  while (bindsLinks.length > 0) {
    const unbind = bindsLinks.shift()!
    unbind()
  }
}

function tagExist(tagName: string) {
  return TAGS.hasOwnProperty(tagName)
}

function bindEventTagOfElement(tagname: string, elem: HTMLElement) {
  if (
    elem.attributes.hasOwnProperty(tagname) &&
    elem.attributes[tagname] &&
    tagExist(elem.attributes[tagname].value)
  ) {
    const handler = evt => onBindTagClick(tagname, evt)
    elem.addEventListener('click', handler)
    bindsLinks.push(() => {
      elem.removeEventListener('click', handler)
    })
    return true
  } else {
    console.log(tagname, 'dont exist at', elem)
  }
  return false
}

function addAllBindClicks() {
  attribute_tag_names.forEach(tagname => {
    document.querySelectorAll(`[${tagname}]`).forEach(elem => {
      bindEventTagOfElement(tagname, elem)
    })
  })
}
function debounce(fnCallback: () => void, time = 500) {
  clearTimeout(debounceTimeId)
  debounceTimeId = setTimeout(fnCallback, time)
}
function onDomChange() {
  debounce(() => {
    clearBindLinks()
    addAllBindClicks()
  })
}
export const getBinds = () => bindsLinks
export const pageViewDataLayer = async () => {
  if (typeof document !== 'undefined') {
    const userInfo = getUserInfo()
    pushData({
      event: 'Page_View',
      action: 'view',
      title: document.title,
      page: window.location.pathname,
      userId: userInfo ? await stringToHash(userInfo.userId) : undefined,
    })
  }
}
export function initTagging() {
  if (executed) {
    return false
  }
  executed = true
  if (!isSSR) {
    observeDOM(document.body, onDomChange)
  }
}

interface ITriggerTageoOptions {
  action?: string
  label?: string
}
export function triggerTageo(
  tag: string,
  options: ITriggerTageoOptions | any = { action: 'click', label: '' }
) {
  const tagdata = TAGS[tag]
  pushData({
    tag,
    ...options,
    ...tagdata,
  })
}
